// extracted by mini-css-extract-plugin
export var priceColumn = "line-item-module--priceColumn--c0a35";
export var remove = "line-item-module--remove--94048";
export var strikeThrough = "line-item-module--strikeThrough--bbfc2";
export var title = "line-item-module--title--fd617";
export var totals = "line-item-module--totals--446e5";
export var variant = "line-item-module--variant--632ee";